import { render } from "./AddPayGrade.vue?vue&type=template&id=e7d85088"
import script from "./AddPayGrade.vue?vue&type=script&lang=js"
export * from "./AddPayGrade.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/localhrm.apcwo.org/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__